module.exports = __webpack_public_path__ + "img/desktop-default.848656fb.png";